import React, { Component } from "react";
import { observer } from "mobx-react";
import SettingDefaultLeftView from "./components/layouts/SettingDefaultLeftView";
import SettingDefaultDeliveryItemView from "./sub/SettingDefaultDeliveryItemView";
import { Link } from "react-router-dom";
import { search_dlv_store_info } from "../../http/dlvCommonConn";
import deliveryImg from "static-file/images/delivery_default.png";
import { fn_devliery_connect_list, fn_dlv_connect_pop } from "function/FnBodyDelivery";
import {
  fn_payfree_info,
  fn_change_df_pickup,
  fn_getDlvSelectListView,
  fn_setDlvSelectListView,
  fn_setDlvSelected,
} from "function/FnBodySetting";

import SettingDefaultDeliveryConnectView from "views/setting/sub/SettingDefaultDeliveryConnectView";

@observer
class SettingDefaultDeliveryView extends Component {
  componentDidMount() {
    const { rootStore } = this.props;
    search_dlv_store_info(rootStore).then(r => {});
  }

  render() {
    const { rootStore } = this.props;
    const settingStore = rootStore.settingStore;
    const deliveryStore = rootStore.deliveryStore;
    let img = deliveryImg;
    let dlvList = [];
    deliveryStore.getExpDelivery.map(list => {
      if (list.use_yn == "Y") {
        dlvList.push(list);
      }
      // if (list.mainUseYn == "Y") {
      //     settingStore.setMainDlv(list.dcode)
      // }
    });
    settingStore.setSettingUseMenu("delivery");
    settingStore.setSettingView(false);

    return (
      <>
        <div className="article_setting">
          {/*왼쪽 메뉴 */}
          <SettingDefaultLeftView rootStore={rootStore} />
          {rootStore.layerStore.getLayerDlvConnectView == false ? (
            <>
              <div className="section_content">
                <h3>배달대행사 관리</h3>
                <div id="dlvScroll" className="scroll">
                  <div className="inner">
                    <div className="wrap_delivery">
                      {rootStore.settingStore.getPayFreeType.paymentUseYn === "0" ? (
                        <div className="list_delivery_none img">
                          <img src={img} alt="delivery_default.png" useMap="#link" width="100%" />
                          <map name="link">
                            <area
                              shape="rect"
                              coords="160,510,490,580"
                              href="#"
                              onClick={event =>
                                fn_payfree_info(
                                  rootStore,
                                  "https://delivery.okpos.co.kr/?utm_source=free_month&utm_medium=agency&utm_campaign=all_plan",
                                  "mktRiderSetup Button"
                                )
                              }
                              alt="1monthFree"
                            />
                          </map>
                        </div>
                      ) : rootStore.settingStore.getPayFreeType.paymentUseYn === "1" ? (
                        <div className="list_delivery_none img">
                          <img src={img} alt="delivery_default.png" useMap="#link" width="100%" />
                          <map name="link">
                            <area
                              shape="rect"
                              coords="168,537,446,585"
                              href="#"
                              onClick={event =>
                                fn_payfree_info(
                                  rootStore,
                                  "https://delivery.okpos.co.kr/?utm_source=free_month&utm_medium=agency&utm_campaign=all_plan",
                                  "mktRiderSetup Button"
                                )
                              }
                              alt="1monthFree"
                            />
                          </map>
                        </div>
                      ) : //( Array.isArray(deliveryStore.getExpDelivery) && deliveryStore.getExpDelivery.length > 0 )
                      Array.isArray(settingStore.getPayFreeType.useDeliveryResList) &&
                        settingStore.getPayFreeType.useDeliveryResList.length > 0 ? (
                        <>
                          <div className="box">
                            <div className="box_tit">
                              <h4>라이더 픽업요청시간 설정</h4>
                            </div>
                            <ul className="list_time">
                              <li>
                                <div className="tit">라이더 픽업요청시간</div>
                                <div className="txt">라이더 호출시간 기본값 설정</div>
                                <div className="time">
                                  <button
                                    type="button"
                                    className="btn_m"
                                    onClick={event => {
                                      event.preventDefault();
                                      fn_change_df_pickup(rootStore, "down");
                                    }}
                                  >
                                    <span
                                      className={settingStore.getDeliveryDfTime == "1" ? "min_disabled" : ""}
                                    ></span>
                                  </button>
                                  <strong>
                                    {settingStore.getPickupDfTime === "1"
                                      ? "즉시"
                                      : settingStore.getPickupDfTime + "분"}
                                  </strong>
                                  <button
                                    type="button"
                                    className="btn_p"
                                    onClick={event => {
                                      event.preventDefault();
                                      fn_change_df_pickup(rootStore, "up");
                                    }}
                                  >
                                    <span
                                      className={settingStore.getDeliveryDfTime == "60" ? "max_disabled" : ""}
                                    ></span>
                                  </button>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="box">
                            <div className="box_tit">
                              <h4>연동 배달대행사</h4>
                              <button
                                type="button"
                                className="btn_add"
                                onClick={event => {
                                  event.preventDefault();
                                  fn_devliery_connect_list(rootStore);
                                }}
                              >
                                <span>추가</span>
                              </button>
                            </div>
                            <ul className="list_delivery">
                              {deliveryStore.getExpDelivery.length > 0
                                ? deliveryStore.getExpDelivery.map((obj, index) => (
                                    <SettingDefaultDeliveryItemView key={index} rootStore={rootStore} obj={obj} />
                                  ))
                                : ""}
                            </ul>
                          </div>
                          <div className="box">
                            <div className="box_tit">
                              <h4>예상배달비 조회</h4>
                              <span className="tit">전화주문 접수화면에서 조회할 예상배달비 대행사 설정</span>
                            </div>
                            <ul className="list_time">
                              <li>
                                <div className="tit_select">배달대행사 선택</div>
                                <div className="select">
                                  <button
                                    type="button"
                                    className={dlvList.length == 0 ? "disabled" : ""}
                                    disabled={dlvList.length == 0 ? "disabled" : ""}
                                    onClick={event => {
                                      fn_setDlvSelectListView(rootStore, !fn_getDlvSelectListView(rootStore));

                                      let objDiv = document.getElementById("dlvScroll");
                                      objDiv.scrollTop = objDiv.scrollHeight;
                                    }}
                                  >
                                    <span>
                                      {settingStore.getMainDlv}
                                      <span className="ico"></span>
                                    </span>
                                  </button>
                                  {dlvList.length > 0 ? (
                                    <ul
                                      className={"layer " + (fn_getDlvSelectListView(rootStore) === true ? "open" : "")}
                                    >
                                      {dlvList.map((list, index) => (
                                        <li className="selectBox" key={index}>
                                          <button
                                            type="button"
                                            onClick={event => {
                                              event.preventDefault();
                                              fn_setDlvSelected(rootStore, list.dumaspDeliveryCode);
                                            }}
                                          >
                                            {list.delivery_name}
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="list_delivery_none">
                            <p className="txt strong">
                              배달대행사 3초만에 연동하고
                              <br />
                              원클릭으로 라이더 호출하세요!
                            </p>
                            <p className="txt">* 배달대행사 프로그램 설치 후에 연동을 진행하세요</p>
                            <div>
                              <button
                                className="btn connect"
                                onClick={event => {
                                  event.preventDefault();
                                  fn_dlv_connect_pop(rootStore);
                                }}
                              >
                                연동하기
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="close">
                    <Link to="/">
                      <button type="button">
                        <span>페이지 닫기</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <SettingDefaultDeliveryConnectView rootStore={rootStore} />
          )}
        </div>
      </>
    );
  }
}

export default SettingDefaultDeliveryView;
